<template>
  <div class="template-padding">
    <div class="row">
      <div class="col col-sm-10">
        <h4 class="font-weight-bolder">
          TRAINING COURSE LIST
        </h4>
      </div>
      <div class="col col-sm-2 text-right">
        <router-link
          to="/trainingCourse/create"
          class="btn btn-sm btn-outline-primary font-weight-bolder mr-4 float-right"
          title="ADD NEW TRAINING COURSE"
          tag="button"
        >
          <span><i class="fas fa-plus" /></span>
          ADD NEW
        </router-link>
      </div>
    </div>

    <form
      class="row pl-3"
      @submit="searchCourse"
    >
      <div class="col col-sm-8 pl-0">
        <div class="input-group mb-3 rounded">
          <select
            class="form-control form-control-xs col col-sm-2 select-center"
            required
            @change="setKey"
            v-model="params.searchKey"
          >
            <option value="code">
              CODE
            </option>
            <option value="name">
              NAME
            </option>
          </select>
          <input
            type="text"
            placeholder="TYPE TO SEARCH HERE"
            class="form-control form-control-xs col col-sm-3"
            v-model="params.searchValue"
          >
          <div class="input-group-prepend rounded-right">
            <button
              type="submit"
              class="input-group-text input-group-append"
            >
              <i class="fas fa-search" />
            </button>
          </div>
        </div>
      </div>

      <div class="col col-sm-4">
        <div class="row">
          <div class="col col-sm-2 text-right offset-6 pt-2 pr-0">
            <label
              for="perPage"
              class="col-form form-label font-weight-bolder text-right"
            >
              <h6><strong>Show:</strong></h6>
            </label>
          </div>
          <div class="col col-sm-4">
            <select
              class="form-control form-control-xs"
              id="perPage"
              v-model="params.perPage"
              @change="searchCourse"
            >
              <option
                v-for="page in numberOfPages"
                :key="page"
                :value="page"
              >
                {{ page }} Records
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>

    <table class="table table-hover table-bordered">
      <thead>
        <tr class="table-header">
          <th class="p-1">
            #
          </th>
          <th class="p-1">
            CODE
          </th>
          <th class="p-1">
            NAME
          </th>
          <th class="p-1">
            # OF DAYS
          </th>
          <th class="p-1">
            STATUS
          </th>
          <th class="col-actions p-1">
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(trainingCourse, index) in trainingCourses"
          :key="trainingCourse.id"
          :class="{'inactive': !trainingCourse.status}"
        >
          <td class="p-1">
            {{ ((paginationLinks.currentPage-1) * paginationLinks.perPage) + (index + 1) }}
          </td>
          <td class="p-1">
            {{ trainingCourse.code }}
          </td>
          <td class="p-1">
            {{ trainingCourse.name }}
          </td>
          <td class="p-1">
            {{ trainingCourse.days }}
          </td>
          <td class="p-1">
            {{ trainingCourse.status | setStatus }}
          </td>
          <td class="p-1">
            <button
              class="btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder"
              :title="`VIEW ${trainingCourse.code} RECORD`"
              @click="viewTrainingCourse(trainingCourse.id)"
            >
              <span><i class="fas fa-eye" /></span>
              VIEW
            </button>
            <button
              class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder"
              :title="`DELETE ${trainingCourse.code} RECORD`"
              @click="removeTrainingCourse(trainingCourse.id)"
            >
              <span><i class="fas fa-trash" /></span>
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <nav aria-label="...">
      <ul class="pagination">
        <li
          class="page-item"
          :class="{ disabled: paginationLinks.currentPage < 2 }"
        >
          <button
            class="page-link"
            tabindex="-1"
            @click="setPage(paginationLinks.currentPage - 1)"
          >
            Previous
          </button>
        </li>

        <li
          class="page-item"
          v-for="trainingCoursePage in trainingCoursePages()"
          :key="trainingCoursePage"
          :class="{ active: (trainingCoursePage === paginationLinks.currentPage) }"
        >
          <button
            @click="setPage(trainingCoursePage)"
            class="page-link"
          >
            {{ trainingCoursePage }}
          </button>
        </li>
        <li
          class="page-item"
          :class="{ disabled: paginationLinks.currentPage+1 > paginationLinks.lastPage }"
        >
          <button
            class="page-link"
            href="#"
            @click="setPage(paginationLinks.currentPage + 1)"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from "../../../mixins/formMixins";

    export default {
        mixins: [ formMixins ],
        name: 'IndexTrainingCourse',
        data() {
            return {
                numberOfPages: [10, 15, 20, 50, 100, 200],
                params: {
                    searchKey: 'name',
                    searchValue: '',
                    trainingCoursePage: 0,
                    perPage: 10
                }
            }
        },
        methods: {
            ...mapActions([ 'getTrainingCourses', 'deleteTrainingCourse' ]),
            viewTrainingCourse(id) {
                this.$router.push(`/trainingCourse/${id}`);
            },

            async removeTrainingCourse(id) {
                if(await this.deleteAlert('Are you sure you want to delete this record?')) {
                    if(await this.deleteTrainingCourse(id)) {
                        this.successAlert('Training Course Successfully Deleted!', 'DELETE');
                    } else {
                        this.errorAlert('Training Course Failed to Delete', 'DELETE');
                    }
                }
            },

            trainingCoursePages() {
                let trainingCoursePages = [];
                for(let i=1; i<=this.paginationLinks.lastPage; i++) {
                    trainingCoursePages.push(i);
                }
                return trainingCoursePages;
            },
            setPage(page) {
                this.params.trainingCoursePage = page;
                this.getTrainingCourses(this.params);
            },
            setKey(e) {
                this.params.searchKey = e.target.value;
            },
            searchCourse(e) {
                e.preventDefault();
                this.getTrainingCourses(this.params);
            }
        },

        computed: {
            ...mapGetters([ 'trainingCourses', 'paginationLinks' ])
        },

        created() {
            this.getTrainingCourses();
        }
    };
</script>

<style scoped>

</style>
